import React from "react";
import { Button } from "react-bootstrap";
import Slider from "react-slick";
import Exclusive1 from '../../assets/images/exclusive1.png'
import Exclusive2 from '../../assets/images/exclusive2.png'
import Exclusive3 from '../../assets/images/exclusive3.png'

function Exclusive() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        initialSlide: 0,
        centerMode: false,
        adaptiveHeight: true,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 3,
                    infinite: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            }

        ]
    };
    return (
        <section className="exclusive-toppy main-padding">
            <div className="container-fluid p-0">
                <div className="heading text-center">
                    <h2>Exclusive Toppy Drops</h2>
                </div>
                <Slider className="exclusive-slider border-slider" {...settings}>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Exclusive1} alt="" className="img-fluid" />
                            </div>
                            <h3>Imlosingmymind</h3>
                            <h6>Abstract works from Kelly Ann Owsiany</h6>
                            <div className="d-flex d-flex justify-content-end">
                                <Button variant="dark">LIVE</Button>
                            </div>
                        </a>
                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Exclusive2} alt="" className="img-fluid" />
                            </div>
                            <h3>Crypto-Pills</h3>
                            <h6>Micha Klein’s virtual medicine for a sick society</h6>
                            <div className="d-flex d-flex justify-content-end">
                                <Button variant="dark">LIVE</Button>
                            </div>
                        </a>
                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Exclusive3} alt="" className="img-fluid" />
                            </div>
                            <h3>BrotChain</h3>
                            <h6>Bitmap generated and rendered entirely by a blockchain contract</h6>
                            <div className="d-flex d-flex justify-content-end">
                                <Button variant="dark">LIVE</Button>
                            </div>
                        </a>
                    </div>
                    <div className="item">
                        <a href="#" >
                            <div className="image">
                                <img src={Exclusive3} alt="" className="img-fluid" />
                            </div>
                            <h3>BrotChain</h3>
                            <h6>Bitmap generated and rendered entirely by a blockchain contract</h6>
                            <div className="d-flex d-flex justify-content-end">
                                <Button variant="dark">LIVE</Button>
                            </div>
                        </a>
                    </div>
                </Slider>
            </div>
        </section>
    )
}
export default Exclusive;